export default "__VITE_ASSET__DgkoFVjw__"